import { Constants } from 'src/app/helper/constants';

export const CREATE_TRAVEL_REQUEST = Constants.HSE_BASE_URL + '/travelrequests';

export const GET_TRAVEL_REQUEST = CREATE_TRAVEL_REQUEST + '/v2/requests';

export const GET_TRAVEL_REQUEST_APPROVALS = CREATE_TRAVEL_REQUEST + '/v2/approvals';

export const UPDATE_TRAVEL_REQUEST = CREATE_TRAVEL_REQUEST + '/updatestatus';

export const CREATE_TRAVEL_APPROVER_SETTINGS = CREATE_TRAVEL_REQUEST + '/settings';

export const POST_TRAVEL_REQUEST_REASSIGN = CREATE_TRAVEL_REQUEST + '/reassign';

export const GET_HSE_SECURITY_RISK = CREATE_TRAVEL_REQUEST + '/securityriskdetails?';

export const GET_TRAVEL_REQUEST_COVID19RISK = CREATE_TRAVEL_REQUEST + '/covid19risk?country='

export const GET_TRAVEL_REQUEST_MEDICALRISK = CREATE_TRAVEL_REQUEST + '/medicalrisk?country='

export const GET_TRAVEL_REQUEST_QUEST_CERTIFICATES = CREATE_TRAVEL_REQUEST + '/questcertifications';

export const POST_ADD_TRAVEL_APPROVER = CREATE_TRAVEL_REQUEST + '/addapprover';

export const POST_REMOVE_TRAVEL_APPROVER = CREATE_TRAVEL_REQUEST + '/deselectapprover';

export const GET_TRAVEL_REQUEST_WITH_ID = CREATE_TRAVEL_REQUEST + '/travelrequestdetails';

export const POST_SEND_TRAVEL_DETAILS = CREATE_TRAVEL_REQUEST + '/actualtraveldetails';

export const GET_COUNTRY_INFORMATION = CREATE_TRAVEL_REQUEST + '/countryinformation';

export const GET_COUNTRY_INFORMATION_DETAILS = CREATE_TRAVEL_REQUEST + '/countryinformationdetails?country=';

export const GET_TRAVEL_REQUEST_APPROVALS_COUNT = CREATE_TRAVEL_REQUEST + '/approvals/count/';

export const GET_TRAVEL_REQUESTS_COUNT = CREATE_TRAVEL_REQUEST + '/requests/count/';

export const GET_TRAVEL_REQUEST_DETAILS = CREATE_TRAVEL_REQUEST + '/';

